import * as Immutable from 'immutable';
import * as t from 'io-ts';

import { Action, ImmutableInterface } from '../../../types/';

export const BaseAchievementElementIO = t.interface({
  id: t.string,
  name: t.string,
  description: t.string,
  achieved: t.union([t.string, t.null]),
  value: t.union([t.number, t.null]),
  total: t.union([t.number, t.null]),
  ratio: t.union([t.number, t.null]),
});

export const BaseAchievementElementsIO = t.array(BaseAchievementElementIO);

export type BaseAchievementElement = t.TypeOf<typeof BaseAchievementElementIO>;

export type AchievementElement = ImmutableInterface<BaseAchievementElement>;
export type AchievementList = Immutable.List<AchievementElement>;

export interface BaseAchievementsStore {
  data: AchievementList;
  isFetching: boolean;
  failure: boolean;
}

export interface AchievementsAction {
  data: any;
}

export type AchievementsStore = ImmutableInterface<BaseAchievementsStore>;
export type AchievementsActionType = Action<AchievementsAction>;
